import { Button, notification, Tooltip } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import React, { useState } from "react";
import axios from "axios";
import { useContractLoader, useBalance } from "../hooks";
import { Transactor } from "../helpers";
import { formatEther, parseEther, formatUnits } from "@ethersproject/units";
import { CONTRACT_NAME_BANNER, MAX_MINTABLE_NFT_BANNER } from "../constants";
import tryToDisplay from "./Contract/utils";

const DEBUG = false;

async function mintNFT({contract, ownerAddress, provider, gasPrice, setStatus}, mintprice, presaleflag, qty) {

  // scaffold-eth's Transactor helper gives us a nice UI popup when a transaction is sent
  const transactor = Transactor(provider, gasPrice);
  let tx;
  console.log("presaleFlag", presaleflag);
  console.log("price", tryToDisplay(mintprice));
  // Trigger the minting and add payment to it.
  if (presaleflag) {
      // PreSale - Free Mint
      tx = await transactor(contract.mintWhitelist(qty));
  }
  else {
      // Regular public sale
      tx = await transactor(contract.mint(qty, { value: mintprice}));
  }

  setStatus("Blockchain transaction sent, waiting confirmation...");

  // Wait for the transaction to be confirmed, then get the token ID out of the emitted Transfer event.
  try {
    const receipt = await tx.wait();
    if (!receipt) {
        setStatus(`The transaction was rejected`);
        return 0;
    }
    //let tokenId = null;
    let listTokenId = [];
    for (const event of receipt.events) {
        if (event.event !== 'Transfer') {
            continue
        }
        else {
          listTokenId.push(event.args.tokenId.toString());
          if (listTokenId.length == qty) {
            break;  
          }
        }
        // tokenId = event.args.tokenId.toString();
        // break;
    }
    //setStatus(`Oracle Banner #${tokenId} minted`);
    setStatus(`Oracle Banner #${listTokenId} minted`);
    //return tokenId;
    return listTokenId;
  } catch (e) {
        console.log(e);
        notification.error({
            message: "Transaction Rejected",
            description: e.message,
        });
        setStatus("Transaction rejected");
  }
}

function updateCounterAPI(nbminted) {
  // set a post request to the NatureOracle API to update the counter for the banner collection
  // const entry = { collection: 'banner_wo', 
  //                 qty: nbminted };
  const entry = `collection=banner_wo&qty=${nbminted}`;

  if (DEBUG) {
    axios.post('http://localhost/natoapi/public/counter.php', entry)
    .then(response => console.log('Counter Update', response.response_desc));
  }
  else {
    // Change URL for official website
    axios.post('https://api.natureoracle.com/counter.php', entry)
    .then(response => console.log('Counter Update', response.response_desc));
  }
}

export default function FreeBannerMintButton({
  customContract,
  account,
  gasPrice,
  signer,
  provider,
  name,
  blockExplorer,
  totalSupply,
  price,
  balance,
  whiteListEnabled,
  publicSaleEnabled,
}) {
  const contracts = useContractLoader(signer);
  let contract;
  if (!name) {
    name = CONTRACT_NAME_BANNER;
  }
  if (!customContract) {
    contract = contracts ? contracts[name] : "";
  } else {
    contract = customContract;
  }

  const address = contract ? contract.address : "";

  const [minting, setMinting] = useState(false);
  const [mintingPreSale, setMintingPreSale] = useState(false);
  const [status, setStatus] = useState("");
  const [tokenId, setTokenId] = useState(null);

  if (DEBUG) console.log("signer balance", tryToDisplay(balance));
  if (DEBUG) console.log("minting cost", tryToDisplay(price));

  // whiteListEnabled for banners is the number of free mint spots left

  // Test if enough NFTs remaining to mint
  const mintRemaining = totalSupply ? (MAX_MINTABLE_NFT_BANNER - totalSupply.toNumber()) > 0 : false;
  const badConnection = totalSupply ? false : true;
  const mintEnabled = (balance && price ) ? balance.gt(price) : false; // add some test for a connected wallet and or switch between the 2 buttons
  //const mintPresaleEnabled = (balance && presaleprice ) ? balance.gt(presaleprice) : false; // add some test for a connected wallet and or switch between the 2 buttons
  const mintPresaleEnabled = true;
  
  const mintedSoFarText = (
    <p className="mint-sofar">
        {tryToDisplay(totalSupply)} / {MAX_MINTABLE_NFT_BANNER} Oracle Banners minted
    </p>
  );

  const badConnectionText = (
    <p className="mint-sofar">
        Connect to Fantom Opera Chain or Refresh Wallet
    </p>
  );

  // TO DO - CHANGE THE CONTRACT TO NFTKEY
  const outOfNFTs = (
    <p className="mint-outofnft">
        Sold out! Find us on <a href="https://operahouse.online/collection/WitchesOracle" target="_blank">OperaHouse</a>.
    </p>
  );

  const startMinting = () => {
    if (DEBUG) console.log(`minting nft ${tryToDisplay(totalSupply)}`);
    setMinting(true);
    signer.getAddress().then(ownerAddress => {
      mintNFT({ 
        contract, 
        provider, 
        ownerAddress, 
        gasPrice, 
        setStatus
      },
        price,
        false,
        1,
      ).then(newTokenId => {
        setMinting(false);
        updateCounterAPI(1);
        console.log('minting complete');
        setTokenId(newTokenId);
      })
    });
  }

  const startPresaleMinting = () => {
    setMintingPreSale(true);
    signer.getAddress().then(ownerAddress => {
      mintNFT({ 
        contract, 
        provider, 
        ownerAddress, 
        gasPrice, 
        setStatus
      },
        0,
        true,
        1,
      ).then(newTokenId => {
        updateCounterAPI(1);
        console.log('minting complete');
        setTokenId(newTokenId);
        setMintingPreSale(false);
      })
    });
  }

  const startPresaleMintingAll = () => {
    setMintingPreSale(true);
    signer.getAddress().then(ownerAddress => {
      mintNFT({ 
        contract, 
        provider, 
        ownerAddress, 
        gasPrice, 
        setStatus
      },
        0,
        true,
        whiteListEnabled,
      ).then(newTokenId => {
        if (newTokenId) {
          updateCounterAPI(newTokenId.length);
        }
        console.log('minting complete');
        setTokenId(newTokenId);
        setMintingPreSale(false);
      })
    });
  }

  const mintPreSaleButton = (
    <Button className="button-minting" type="primary" disabled={!mintPresaleEnabled || minting} onClick={startPresaleMinting}>
      {mintingPreSale ? <LoadingOutlined/> : "MINT 1 FREE BANNER"}
    </Button>
  )

  const mintPreSaleButtonAll = (
    <Button className="button-minting" type="primary" disabled={!mintPresaleEnabled || minting} onClick={startPresaleMintingAll}>
      {mintingPreSale ? <LoadingOutlined/> : "MINT ALL MY BANNERS"}
    </Button>
  )

  const minterSection = (
    <div style={{ margin: "auto", width: "650px" }}>
        {badConnection ? badConnectionText : mintedSoFarText}
        {(!badConnection && !mintRemaining) ? outOfNFTs : ""}
        <p>
            {status}
        </p>
        <p className="content content-witches">
            {mintRemaining && whiteListEnabled && (whiteListEnabled > 0) ? "Note: You have " + whiteListEnabled + " Oracle Banner NFT(s) left to mint" : ""}
        </p>
        <p className="content content-witches">
            {mintRemaining && !publicSaleEnabled && (!whiteListEnabled || (whiteListEnabled == 0)) ? "If your wallet has free mint spots left, your mint button will appear shortly.." : ""}
        </p>
        <p>
          {mintRemaining && whiteListEnabled && (whiteListEnabled > 0) ? mintPreSaleButton : ""}
        </p>
        <p>
          {mintRemaining && whiteListEnabled && (whiteListEnabled > 0) ? mintPreSaleButtonAll : ""}
        </p>
    </div>
  );


  return minterSection;
}
